<template>
  <div v-show="ctrl.active || ctrl.force" class="modal is-active"
       :class="{'is-large': ctrl.isLarge}">
    <div class="modal-background" :class="{'is-active': ctrl.active}" @click="close()"></div>
    <div v-show="ctrl.active || ctrl.force" class="modal-card " >
      <slot name="modal-card-body">
        <section class="modal-card-body"
                 @click="ctrl.noHeader && !ctrl.manualClose && (close())"
                 :class="{'is-paddingless': ctrl.noPadding}">
          <p v-show="!ctrl.noHeader" class="modal-card-head">
            <slot name="title"></slot>
            <v-color-icon v-show="!ctrl.force" name="close" class="flex-pull-right"
                          @click="close()"></v-color-icon>
          </p>
          <div class="modal-card-content">
            <slot name="body"></slot>
          </div>
          <div v-show="!ctrl.noFooter" class="modal-card-foot">
            <slot v-show="!ctrl.noHeader" name="foot"></slot>
          </div>
        </section>
      </slot>
    </div>
  </div>
</template>
<style lang="stylus" scoped>
.modal-background {
  transition: all .3s;
  background rgba(0, 0, 0, .5)
}

.modal-background.is-active {
  animation: fadeIn .3s ease-out;
}

@media (min-width: 767px) {
  .modal.is-large .modal-card {
    width: 80% !important;
  }
}

.modal, .modal-transition {
  z-index $zIndexModal
}

.modal-card {
  border-radius: 5px;
  animation fadeUpIn .6s
}

.modal.is-portal {
  position: absolute;
}

.modal-card-head {
  margin: -20px -20px 30px -20px;
  display: flex;
  font-size: 1.5rem;
  background: #E8EBF0;
}

.modal-card-foot {
  margin: 30px -20px -20px -20px;
  background: #E8EBF0;
}

.modal-card-body {
  overflow-y: auto;
  overflow-x: hidden;
}

.is-large .modal-card-content {
  min-height: 50vh;
}

@media screen and (max-width: 767px) {
  .modal .modal-card {
    width: 100vw !important;
    max-height: 100%;
    margin: 0;
  }

  .modal .modal-background {
    /*background: #c9c9c9;*/
  }

  .modal footer {
    /*height: 20vh;*/
    padding-bottom: 0;
  }
}
</style>
<script>
export default {
  props: ['ctrl'],
  data () {
    return {
      scrollTop: 0
    }
  },
  watch: {
    'ctrl.active' (value) {
      if (value) {
        this.scrollTop = this.getScrollTop()
        document.body.style.height = '100vh'
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflowY = 'scroll'
        this.$nextTick(() => {
          document.body.scrollTop = this.scrollTop
        })
        document.addEventListener('keydown', this.onKeyDown)
      } else {
        document.body.style.height = 'initial'
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
        document.documentElement.style.overflowY = 'initial'

        this.$nextTick(() => {
          window.scrollTo(0, this.scrollTop)
        })
        document.removeEventListener('keydown', this.onKeyDown)
      }
    }
  },
  beforeDestroy () {
    document.body.style.height = 'initial'
    document.body.style.position = 'initial'
    document.removeEventListener('keydown', this.onKeyDown)
  },
  methods: {
    close () {
      if (!this.ctrl.force) {
        this.ctrl.active = false
      }
    },
    getScrollTop () {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
    onKeyDown ($event) {
      if ($event.key === 'Escape') {
        this.close()
      }
      return true
    }
  }
}
</script>
